export function createNetworkError(cause?: unknown) {
  return Object.assign(new TypeError('Failed to fetch'), {
    cause,
  })
}
